/* eslint-disable react/prop-types */
import React from 'react';
import { Typography, Paper, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import { ExpandMore, TouchApp } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';

import OutGraph from '../../../components/Graphics/OutGraph';
import DataTable from '../../../components/DataTable/DataTable';


class LeaveChart extends React.Component {
  state = {
    defaultList: [],
    offscaleData: [],
    offscaleInfo: null,
    selectedSlice: null,
  };

  componentDidMount() {
    if (this.props.data) {
      this.fetchOffscale();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.department !== this.props.department || prevProps.data !== this.props.data) {
      this.fetchOffscale();
    }
  }

  setChartConfig = (employeesList) => {
    const beforeCount = employeesList.filter(employee => employee.late < 0).length;
    const afterCount = employeesList.filter(employee => employee.late > 0).length;


    return [{ tempo: 'Mais que 10 min', antes: beforeCount, depois: afterCount }];
  }

  fetchOffscale = () => {
    // axios
    //   .get('/bi/dashboard/offScale')
    //   .then((response) => {
    const response = this.props.data;
    const employeeList = response.data.filter((obj) => {
      if (this.props.department > 0) {
        return obj.employee.departmentId === this.props.department;
      }
      return obj;
    });

    this.setState({
      defaultList: [...employeeList],
      offscaleData: employeeList.filter(employee => employee.registeredToday),
      offscaleInfo: this.setChartConfig(employeeList.filter(employee => employee.registeredToday)),
    });
    // })
  }

  initializeDateItemForm = (item) => {
    if (item) {
      item
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/');
      const hour = item.split('T')[1].split('.')[0];

      return `${hour}`;
    }
    return '';
  };

  onClick = (barInfo) => {
    let newValue = null;

    if (barInfo.id !== this.state.selectedSlice) {
      newValue = barInfo.id;
    }

    this.setState({
      selectedSlice: newValue,
    }, () => {
      this.filterChart();
    });
  }

  filterChart = () => {
    let nextList = [...this.state.defaultList].filter(i => i.registeredToday);
    if (this.state.selectedSlice === 'antes') {
      nextList = nextList.filter(employee => employee.late < 0);
    } else if (this.state.selectedSlice === 'depois') {
      nextList = nextList.filter(employee => employee.late > 0);
    }

    this.setState({
      offscaleData: nextList,
    });
  }

  renderList = () => {
    const absencesColumns = [
      { name: 'name', label: 'Nome' },
      { name: 'dtHour', label: 'Saída' },
      { name: 'late', label: 'Saída2' }
    ];

    const info = this.state.offscaleData.map(employee => ({
      ...employee,
      dtHour: this.initializeDateItemForm(employee.dtRegister),
      name: (
        <div>
          <div style={{
            background: employee.late < 0 ? '#F8DD4E' : '#FF7474', width: 10, height: 10, borderRadius: 50, padingRigth: 10, display: 'inline-block'
          }} />
          <span>
            {'    '}{employee.employee.name}
          </span>
        </div>
      ),
    }));

    return (
      <DataTable
        rows={info || []}
        columns={absencesColumns}
        outRowsPerPage={5}
        pagination
      />
    );
  }

  render() {
    const { classes } = this.props;

    const colors = { antes: '#F8DD4E', depois: '#FF7474' };
    const getColor = bar => colors[bar.id];
    return (
      <Grid>
        <Paper elevation={2} style={{ flexBasis: '40%', margin: 'auto', marginTop: 'initial' }} className={classes.paperGraphics} data-tut="reactour__Faltantes">
          <Typography
            variant="h6"
            component="h4"
            color="textSecondary"
            align="left"
            style={{ padding: 20, fontColor: '#8898AA', fontSize: 15 }}
          >
            {' Saída Divergente '}
          </Typography>

          <div
            style={{
              height: 300,
              //minWidth: 300,
              padding: '10px',
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              cursor: !this.state.offscaleData.length ? 'default' : 'pointer',
            }}
          >
            {
              !this.state.offscaleData.length ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <TouchApp color="disabled" style={{ fontSize: 100, paddingBottom: 20 }} />
                  <Typography component="h3" color="textSecondary" align="center">
                    Nenhum funcionário registrou ponto de saída divergente
                  </Typography>
                </div>
              ) :
                <OutGraph data={this.state.offscaleInfo} colors={getColor} onClick={this.onClick} selectedSlice={this.state.selectedSlice} />
            }
          </div>
        </Paper>
        <ExpansionPanel style={{ marginTop: 0 }} >
          <ExpansionPanelSummary expandIcon={<ExpandMore />} IconButtonProps={{ style: { position: 'absolute', right: '14px' } }} >
            <Typography className={classes.heading}> Ver Detalhes </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ padding: 0 }}>
            {this.renderList()}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Grid>
    );
  }
}

export default LeaveChart;
